import React, { useState, useEffect } from 'react';
import Header from './components/header/Header'
import Toast from './components/common/toastMessage/toastMessage'
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import 'react-loading-skeleton/dist/skeleton.css'
import Dashboard from "./components/dashboard/Dashboard";
import SearchResults from "./components/searchResults/SearchResults";
import Links from "./components/links/links";
import AllEvents from "./components/allEvents/AllEvents";
import Announcement from "./components/announcement/Announcement";
import LeadershipTabs from "./components/leadershipTabs/leadershipTabs";
import Kr from "./components/kr/Kr";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import helpers from './components/helpers';
import * as $ from "jquery";
import PageLoader from './components/pageLoader/PageLoader';
import { useSelector, RootStateOrAny, useDispatch } from 'react-redux';
import { AppInsights } from "applicationinsights-js";
import type { MSALOptions } from "@pnp/msaljsclient";
import { spfi, SPBrowser, SPFI } from "@pnp/sp";
import { MSAL, getMSAL } from "@pnp/msaljsclient";
import { useMsal } from "@azure/msal-react";
import "@pnp/sp/webs";
import "@pnp/sp/site-users/web";
import "@pnp/sp/lists";
import "@pnp/sp/items";

let layoutColumnID;

const App = (props) => {

    const [isModerator, setIsModerator] = useState<boolean>(false);
    const [isEmail, setIsEmail] = useState();
    const [isSiteName, setIsSiteName] = useState("");
    const [editMode, setEditMode] = useState<boolean>(false);
    const [layout, setLayout] = useState();
    const [showToast, setToast] = useState(false);
    //const [showBrowserAlert, setShowBrowserAlert] = useState(false);
    const [MenuLinks, setMenuLinks] = useState([{ category: "", links: [] }]);
    const appweburl = helpers.appweburl;
    const hostweburl = helpers.hostweburl;
    const [initialLayout1, setInitialLayout1] = useState();
    const [isLoading, setLoading] = useState(true);
    const [showOverlayLoader, setShowOverlayLoader] = useState(true);

    const [response, setResponse] = useState([]);
    const [webpartVisibilty, setWebpartVisibilty] = useState({});
    const [showLoading, setShowLoading] = useState(true);

    let showGlobalLoader = useSelector((state: RootStateOrAny) => state.showGlobalLoader)

    useEffect(() => {
        setShowOverlayLoader(showGlobalLoader);
    }, [showGlobalLoader])

    useEffect(() => {
        if (window['SP_Propertyweb'] === undefined) {
            setTimeout(() => {
                getCustomWebpart();
            }, 2000);
        }
        else {
            getCustomWebpart();
        }
    }, [isModerator])

    useEffect(() => {
        if (window['SP_Propertyweb'] === undefined) {
            setTimeout(() => {
                getLinksForHeader();
                getwebpartsVisibility();
                /* Call downloadAndSetup to download full ApplicationInsights script from CDN and initialize it with instrumentation key */
                AppInsights.downloadAndSetup({ instrumentationKey: helpers.appinsightsinstrumentationKey, maxBatchSizeInBytes: 0 });

                helpers.getAllDataSortedNew("SpoAPageData", (res) => {
                    layoutColumnID = res[0].ID;
                    setLayout(JSON.parse(res[0].Query));
                    localStorage.clear();
                    setLoading(false);
                }, (e) => { console.error('Fetching layout!' + e); }, null, null, "Section eq 'Layout'", null, null);

            }, 2000);
        }
        else {
            getLinksForHeader();
            getwebpartsVisibility();
            /* Call downloadAndSetup to download full ApplicationInsights script from CDN and initialize it with instrumentation key */
            AppInsights.downloadAndSetup({ instrumentationKey: helpers.appinsightsinstrumentationKey, maxBatchSizeInBytes: 0 });

            helpers.getAllDataSortedNew("SpoAPageData", (res) => {
                layoutColumnID = res[0].ID;
                setLayout(JSON.parse(res[0].Query));
                localStorage.clear();
                setLoading(false);
            }, (e) => { console.error('Fetching layout!' + e); }, null, null, "Section eq 'Layout'", null, null);

        }

        // const browser = detect();

        // if (browser.name != "chrome")
        // {
        //     setShowBrowserAlert(true);
        // } 

        return () => {
            localStorage.clear()
        }

    }, [])

    useEffect(() => {
        //let sitename = location.pathname.split("/")[1];
        if (window.location.href.toLowerCase().indexOf('localhost') !== -1) {
            setIsSiteName("Environment");
        }
        else {
            if (window['SP_PropertyRootWeb'] === undefined) {
                setTimeout(() => {
                    helpers.getAllDataSortedRoot("SPoASiteName", (response) => {
                        response.map(o => {
                            if (o.SiteURL.Url.toLowerCase() === helpers.hostweburl.toLowerCase()) {
                                setIsSiteName(o.Title);
                            }
                        });
                    }, (e) => { console.error('Fetching site name!' + e); }, ["Title", "SiteURL"], null, null, null, 4999);
                }, 2000);
            }
            else {
                helpers.getAllDataSortedRoot("SPoASiteName", (response) => {
                    response.map(o => {
                        if (o.SiteURL.Url.toLowerCase() === helpers.hostweburl.toLowerCase()) {
                            setIsSiteName(o.Title);
                        }
                    });
                }, (e) => { console.error('Fetching site name!' + e); }, ["Title", "SiteURL"], null, null, null, 4999);
            }
        }
    }, []);

    useEffect(() => {
        //getSPoASearchresults();
    }, [])

    useEffect(() => {
        if (window.location.href.toLowerCase().indexOf('localhost') !== -1) {
            setIsModerator(true);
        }

        else {
            if (window['SP_Propertyweb'] === undefined) {
                setTimeout(() => {
                    window['SP_Propertyweb'].lists.getByTitle('Discipline Configuration').items.filter("Title eq 'ModeratorsGroupID'")().then((res) => {
                        helpers.getUser((e: any) => {
                            setIsEmail(e.Email);
                            helpers.getUserGroupdetails(e.Id, (group: any) => {
                                group.map(o => {
                                    if (o.Title.toLowerCase().indexOf('owners') !== -1 || o.Id == res[0].SpoAConfigValue) {
                                        setIsModerator(true);
                                    }
                                });
                            });

                        });
                    }).catch(e => {
                        console.error('Error fetching moderator group ID!');
                    });
                }, 2000);
            }
            else {
                window['SP_Propertyweb'].lists.getByTitle('Discipline Configuration').items.filter("Title eq 'ModeratorsGroupID'")().then((res) => {
                    helpers.getUser((e: any) => {
                        setIsEmail(e.Email);
                        helpers.getUserGroupdetails(e.Id, (group: any) => {
                            group.map(o => {
                                if (o.Title.toLowerCase().indexOf('owners') !== -1 || o.Id == res[0].SpoAConfigValue) {
                                    setIsModerator(true);
                                }
                            });
                        });

                    });
                }).catch(e => {
                    console.error('Error fetching moderator group ID!');
                });
            }
        }
    }, [])

    function onResetLayout() {
        setLoading(true);
        const defaultLayout = JSON.stringify([{ "w": 8, "h": 10, "x": 0, "y": 0, "i": "a", "minW": 4, "minH": 9, "isResizable": false, "isDraggable": false }, { "w": 4, "h": 10, "x": 8, "y": 0, "i": "b", "minW": 4, "minH": 4, "isResizable": false, "isDraggable": false }, { "w": 12, "h": 10, "x": 0, "y": 10, "i": "c", "minW": 4, "minH": 4, "maxH": 10, "isResizable": false, "isDraggable": false }, { "w": 12, "h": 8, "x": 0, "y": 20, "i": "d", "minW": 4, "minH": 8, "isResizable": false, "isDraggable": false }, { "w": 12, "h": 8, "x": 0, "y": 28, "i": "e", "minW": 4, "minH": 8, "isResizable": false, "isDraggable": false }, { "w": 12, "h": 8, "x": 6, "y": 36, "i": "f", "minW": 4, "minH": 8, "isResizable": false, "isDraggable": false }, { "w": 12, "h": 8, "x": 0, "y": 44, "i": "g", "minW": 4, "minH": 8, "isResizable": false, "isDraggable": false }, { "w": 12, "h": 18, "x": 0, "y": 52, "i": "h", "minW": 4, "minH": 18, "isResizable": false, "isDraggable": false }, { "w": 12, "h": 5, "x": 0, "y": 68, "i": "i", "isResizable": false, "isDraggable": false }, { "w": 12, "h": 5, "x": 0, "y": 76, "i": "j", "isResizable": false, "isDraggable": false }, { "w": 12, "h": 5, "x": 0, "y": 84, "i": "k", "isResizable": false, "isDraggable": false }, { "w": 12, "h": 5, "x": 0, "y": 92, "i": "l", "isResizable": false, "isDraggable": false }, { "w": 12, "h": 5, "x": 0, "y": 100, "i": "m", "isResizable": false, "isDraggable": false }, { "w": 12, "h": 5, "x": 0, "y": 108, "i": "n", "isResizable": false, "isDraggable": false }, { "w": 12, "h": 5, "x": 0, "y": 116, "i": "o", "isResizable": false, "isDraggable": false }, { "w": 12, "h": 5, "x": 0, "y": 124, "i": "p", "isResizable": false, "isDraggable": false }, { "w": 12, "h": 12, "x": 0, "y": 10, "i": "q", "isResizable": false, "isDraggable": false }, { "w": 12, "h": 8, "x": 0, "y": 60, "i": "r", "moved": false, "static": false, "isDraggable": false, "isResizable": false }, { "w": 12, "h": 8, "x": 0, "y": 130, "i": "s", "moved": false, "static": false, "isDraggable": false, "isResizable": false }]);
        helpers.updateData("SpoAPageData", { Query: defaultLayout }, layoutColumnID, () => {
            setLayout(JSON.parse(defaultLayout));
            localStorage.clear();
            setLoading(false);
        })
    }


    function handleEdit(mode: boolean) {
        if (!mode) {
            setLoading(true);
            let updatedLayout;
            if (localStorage.layout == undefined) {
                updatedLayout = JSON.parse(JSON.stringify(layout));
                updatedLayout = updatedLayout.map(o => {
                    o.isResizable = false;
                    o.isDraggable = false;
                    return o;
                });
            } else {
                updatedLayout = JSON.parse(localStorage.layout);
                updatedLayout = updatedLayout.map(o => {
                    o.isResizable = false;
                    o.isDraggable = false;
                    return o;
                });
            }
            helpers.updateData("SpoAPageData", { Query: JSON.stringify(updatedLayout) }, layoutColumnID, () => {
                setLayout(updatedLayout);
                localStorage.clear();
                setLoading(false);
                setToast(!mode);
            })
        }
        else {
            let obj = JSON.parse(JSON.stringify(layout));
            const tempLayout = obj.map((tile: any) => {
                if (tile.i !== "c") {
                    tile.isResizable = !tile.isResizable;
                    tile.isDraggable = !tile.isDraggable;
                } else if (tile.i === "c") {
                    tile.isDraggable = !tile.isDraggable;
                }
                return tile;
            })
            setLayout(tempLayout);
        }


        // if(mode === false) {
        //     document.body.classList.remove('edit-q');
        //     document.body.classList.remove('zoom-out');
        // } else {
        //     document.body.classList.add('edit-q');
        // }

        setEditMode(mode);


    }

    return (
        <div className="App">
            {showOverlayLoader && <PageLoader />}
            <Toast showToast={showToast} onClose={() => setToast(false)} messageType="changesSaved" />
            {/* <Toast showToast={showBrowserAlert} onClose={() => setShowBrowserAlert(false)} messageType = "browserAlert" /> */}
            <Header editMode={editMode} MenuLinks={MenuLinks} setEditMode={handleEdit} isModerator={isModerator} isEmail={isEmail} isSiteName={isSiteName} onResetLayout={onResetLayout} response={response} getCustomWebpart={getCustomWebpart} getwebpartsVisibility={getwebpartsVisibility} AppInsights={AppInsights} />

            {
                isLoading ? "Loading..." :
                    <Routes>
                        <Route path="/:id/dashboard" element={<Dashboard editMode={editMode} layout={layout} getCustomWebpart={getCustomWebpart} response={response} isModerator={isModerator} showLoading={showLoading} setShowLoading={setShowLoading} setLayout={setLayout} AppInsights={AppInsights} userEmail={isEmail} webpartVisibilty={webpartVisibilty} isSiteName={isSiteName} />} />
                        <Route path="/:id/leadership-and-team" element={<LeadershipTabs editMode={editMode} component={LeadershipTabs} AppInsights={AppInsights} userEmail={isEmail} />} />
                        <Route path="/:id/announcement" element={<Announcement editMode={editMode} isModerator={isModerator} component={Announcement} AppInsights={AppInsights} userEmail={isEmail} />} />
                        <Route path="/:id/events" element={<AllEvents editMode={editMode} component={AllEvents} AppInsights={AppInsights} userEmail={isEmail} />} />
                        <Route path="/:id/links" element={<Links editMode={editMode} getLinksForHeader={getLinksForHeader} component={Links} AppInsights={AppInsights} userEmail={isEmail} />} />
                        <Route path="/:id/kr" element={<Kr editMode={editMode} component={Kr} AppInsights={AppInsights} userEmail={isEmail} />} />
                        <Route path="/:id/search" element={<SearchResults editMode={editMode} component={SearchResults} isSiteName={isSiteName} />} />

                    </Routes>
            }
        </div>
    );

    function getCustomWebpart() {
        setShowLoading(true);
        helpers.getAllData("CustomWebpart", ((items: Array<{
            Title: string,
            Body: string,
            LinkWebpage: string,
            IsVisible: boolean,
            ID: boolean

        }>) => {
            let setItems = [];
            for (let i = 0; i < items.length; i++) {
                let descBody = '';
                descBody = items[i].Body;
                descBody = descBody.replace(/<figure><img src="[/]*sites/g, '<figure><img src="' + helpers.rootSiteCollection);
                descBody = descBody.replace(/<img src="[/]*sites/g, '<img src="' + helpers.rootSiteCollection);
                descBody = descBody.replace(/<figure><img src="[/&#58;i&#58;/r/]*sites/g, '<figure><img src="' + helpers.rootSiteCollection);
                descBody = descBody.replace(/<figure><img height="auto" src="[/&#58;i&#58;/r/]*sites/g, '<figure><img src="' + helpers.rootSiteCollection);
                descBody = descBody.replace(/<a href="[/]*sites/g, '<a href="' + helpers.rootSiteCollection);
                descBody = descBody.replace(/<area href="[/]*sites/g, '<area href="' + helpers.rootSiteCollection);
                descBody = descBody.replace(/<a href="[/&#58;x&#58;/r/]*sites/g, '<a href="' + helpers.rootSiteCollection);
                descBody = descBody.replace(/<a href="[/&#58;w&#58;/r/]*sites/g, '<a href="' + helpers.rootSiteCollection);
                descBody = descBody.replace(/<a href="[/&#58;p&#58;/r/]*sites/g, '<a href="' + helpers.rootSiteCollection);
                descBody = descBody.replace(/<a href="[/&#58;b&#58;/r/]*sites/g, '<a href="' + helpers.rootSiteCollection);
                setItems.push({
                    Title: items[i].Title,
                    Body: descBody,
                    LinkWebpage: items[i].LinkWebpage,
                    IsVisible: items[i].IsVisible,
                    ID: items[i].ID,
                })
            }
            setResponse(setItems);
            setShowLoading(false);
        }), ["Title", "ID", "Body", "LinkWebpage", "IsVisible"], "", "ID", "");

    }

    function getLinksForHeader() {
        helpers.getAllDataSortedNew("Main Link Categories", ((MainLinks_items: any[]) => {
            let setMainLinksCategory: any = [];
            //MainLinks_items.map(o => {
            //    //Validating the shown on home page response
            //    setMainLinksCategory.push({ Title: encodeURIComponent(o.Title) })
            //})
            MainLinks_items.forEach(function (o) {
                setMainLinksCategory.push({ Title: encodeURIComponent(o.Title) });
            })
            // setMymainlinks(setMainLinksCategory);
            //Passing the response to another method to load the links data

            getData(setMainLinksCategory);
        }), ((e: any) => { console.log(e); }), ["Title", "SpoAShowOnLanding"], null, "SpoAShowOnLanding eq 1", [{ field: "SpoAOrder", order: true }], 4999);
    }
    //

    //#region  Getting the data from links list based on main link categories response 
    function getData(myMainLinksCall: any) {
        let setLinks_val: any = {};
        //Creating bacth to execute the multiple calls        
        const columns = ["ID", "URL", "LinkURL", "Title", "ShowOnLanding", "SpoALinkType", "SpoAOrder", "MainLinkCategory/Title", "MainLinkCategory/Id"];
        const expandCol = ["MainLinkCategory"];

        //Prepare empty/resolved promise to iterate later
        var promise = Promise.resolve(null);
        //Loop through every field 
        $.each(myMainLinksCall, function (i) {
            promise = promise.then(executeRequest(myMainLinksCall[i].Title));
        });
        //execute callback when all fields are created
        promise.then(() => {
            let obj: any = setLinks_val;
            setMenuLinks(obj);
        });

        //Promise returning request
        function executeRequest(fieldConfig) {
            return function () {
                return new Promise(function (resolve, reject) {
                    let filter = "(MainLinkCategory / Title eq '" + decodeURIComponent(fieldConfig) + "') and (SpoAHidden eq 0) and((SpoALinkType eq 'ShowOnHomePage') or (ShowOnLanding eq 1))'";
                    helpers.getAllDataSortedWithoutCallback("Links", columns, expandCol, filter, [{ field: "SpoAOrder", order: true }], 5).then((items) => {
                        if (items.length > 0) {
                            items.forEach(function (o) {
                                if (!setLinks_val[o.MainLinkCategory.Title]) {
                                    setLinks_val[o.MainLinkCategory.Title] = {};
                                    setLinks_val[o.MainLinkCategory.Title]["category"] = o.MainLinkCategory.Title;
                                    setLinks_val[o.MainLinkCategory.Title]["MId"] = o.MainLinkCategory.Id;
                                    setLinks_val[o.MainLinkCategory.Title]["id"] = o.ID;
                                    setLinks_val[o.MainLinkCategory.Title]["links"] = []
                                }
                                setLinks_val[o.MainLinkCategory.Title]["links"].push({ URL: o.LinkURL, Title: o.Title });
                            });
                        }
                        else {
                            setLinks_val[fieldConfig] = {};
                            setLinks_val[fieldConfig]["category"] = decodeURIComponent(fieldConfig);
                            setLinks_val[fieldConfig]["id"] = 1;
                            setLinks_val[fieldConfig]["links"] = []
                        }
                        resolve(setLinks_val);
                    });
                });
            };
        }
    }

    function getDataformainlink(myMainLinksCall: any) {
        let setLinks_val: any = {};
        //Creating bacth to execute the multiple calls
        const [batchedSP, execute] = window['SP_Propertyweb'].batched();
        const columns = "ID,URL,Title,LinkURL,ShowOnLanding,SpoALinkType,SpoAOrder,MainLinkCategory/Title,MainLinkCategory/Id";
        const expandCol = "MainLinkCategory";
        if (myMainLinksCall) {
            for (let i = 0; i < myMainLinksCall.length; i++) {
                batchedSP.lists.getByTitle("Links").items.select(columns).expand(expandCol).
                    filter("(MainLinkCategory/Title eq '" + myMainLinksCall[i].Title + "') and (SpoAHidden eq 0) and ((SpoALinkType eq 'ShowOnHomePage') or (ShowOnLanding eq 1))").
                    orderBy("SpoAOrder")().then((itemslink: any[]) => {
                        //Creating an array to bind the data in mega-menu
                        itemslink.forEach(o => {
                            if (!setLinks_val[o.MainLinkCategory.Title]) {
                                setLinks_val[o.MainLinkCategory.Title] = {};
                                setLinks_val[o.MainLinkCategory.Title]["category"] = o.MainLinkCategory.Title;
                                setLinks_val[o.MainLinkCategory.Title]["MId"] = o.MainLinkCategory.Id;
                                setLinks_val[o.MainLinkCategory.Title]["id"] = o.ID;
                                setLinks_val[o.MainLinkCategory.Title]["links"] = []
                            }
                            setLinks_val[o.MainLinkCategory.Title]["links"].push({ URL: o.LinkURL, Title: o.Title })
                        })
                    })
            }
            //Loading the batch data after final response
            execute().then(function () {
                let obj: any = setLinks_val;
                if (Object.keys(obj).length === 0) { obj.empty = true; }
                setMenuLinks(obj);
            }
            )

        }

    }
    //#endregion

    function getwebpartsVisibility() {
        helpers.getAllData("SpoAPageData", function (response) {
            var obj = {};
            response.map((item: any) => {
                obj[item.Application] = item.IsHidden;
            })
            setWebpartVisibilty(obj);
        });
    }

    function getSPoASearchresults() {
        let querytext = 'SPoA+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/ccus\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/CoP%20PE%20Concept%20Engineering\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Exploration\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Front%20End%20Development%20Management\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Production%20Geosciences\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Geomatics\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Geophysics\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/IntAct\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/IRM\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Petrophyscis+and+Geomechanics\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Production+Chemistry\"+OR+path:\"https://eu001-sp.shell.com/sites/aaaaa9133/Reservoir%20Engineering\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/TechnicalDataManagement\"';
        helpers.getsearchResults(querytext, null, null, 100, onGetSearchResultsDocumnetSuccess, onGetSearchResultsFail);
    }

    function onGetSearchResultsDocumnetSuccess(data) {
        let jsonDiscussionResults = data.PrimarySearchResults;
        console.log("First API call : " + jsonDiscussionResults.length);
        let querytext = 'safety+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/TSE\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Gen_SE_IIL\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Safety_Bus_Travel\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Safety_Cleaning_Storage_Tanks\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Safety_ConfinedSpace\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Safety_Diving_Tunnelling\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Safety_Elec_Safety\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Safety_IR\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Safety_LH_MHE\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Ops_Safety\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Gen_SE_PTW\"+OR+path:\"https://eu001-sp.shell.com/sites/aaaaa9133/Safety_PPE\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Safety_Safe_Isolation\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Safety_Working_at_Height\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/GEM\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Gen_SE_Contractor_HSSE_Management\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Prod_Stewardship\"+OR+path:\"https://eu001-sp.shell.com/sites/aaaaa9133/Safety_Road_Safety\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Work_Welfare\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/Gen_SE_Behav_Ldrshp_HSSE\"+OR+path:\"https://eu001-sp.shell.com/sites/aaaaa9133/IHA\"+OR+path:\"https://eu001-sp.shell.com/sites/AAAAA9133/HSSE_CritPos\"';
        helpers.getsearchResults(querytext, null, null, 100, onGetSearchResultssecondSuccess, onGetSearchResultsFail);
    }

    function onGetSearchResultssecondSuccess(data) {
        let jsonDiscussionResults = data.PrimarySearchResults;
        console.log("Second API call : " + jsonDiscussionResults.length);
    }
    function onGetSearchResultsFail(data, errorCode, errorMessage) {
        console.log('An error occurred whilst searching for related content - ' + errorMessage);
    }

}
export default App;
